import { render, staticRenderFns } from "./BoxView.vue?vue&type=template&id=4c325af2&scoped=true&"
import script from "./BoxView.vue?vue&type=script&lang=js&"
export * from "./BoxView.vue?vue&type=script&lang=js&"
import style0 from "./BoxView.vue?vue&type=style&index=0&id=4c325af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c325af2",
  null
  
)

export default component.exports